
 
(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get('redirect');

  // Skip redirection if redirect=true is present
  if (myParam === 'true') {
    return;
  }

  fetch('https://api.ipregistry.co/?key=gskjnm4opqdvy2fg')
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'IPRegistry request failed with status: ' + response.status
        );
      }

      return response.json();
    })
    .then(function (payload) {
      if (!payload || typeof payload !== 'object') {
        console.error('Invalid IPRegistry response:', payload);
        return;
      }

      // Skip redirection for specific IPs
      if (
        payload.ip === '103.183.34.116' ||
        payload.ip === '115.96.217.167'
      ) {
        return;
      }

      const countryCode = payload.location?.country?.code;

      // Continue only when country information is available
      if (!countryCode) {
        console.warn('Country information unavailable:', payload);
        return;
      }

      // Redirect only visitors from India
      if (countryCode !== 'IN') {
        return;
      }

      const userAgent = navigator.userAgent;

      const isExcludedUserAgent =
        /(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/.test(userAgent);

      if (isExcludedUserAgent) {
        return;
      }

      // Preserve the current page path
      const pageUrl =
        'https://www.behno.in' + window.location.pathname;

      window.location.href = pageUrl;
    })
    .catch(function (error) {
      console.error('IP location check failed:', error);
    });
})();
    
    // document.addEventListener('DOMContentLoaded', function () {
      //     const urlParams = new URLSearchParams(window.location.search);
      //     const myParam = urlParams.get('redirect');
      //     // const myParam = "true";
      //     if (myParam == 'true') {
      //       // Do nothing if 'redirect=true' is present in URL
      //     } else {
      //       fetch('https://api.ipregistry.co/?key=gskjnm4opqdvy2fg')
      //         .then(function (response) {
      //           return response.json();
      //         })
      //         .then(async function (payload) {
      //           if (payload.ip === '103.183.34.116' || payload.ip === '115.96.217.167') {
      //             // Skip redirection for specific IPs
      //           } else {
      //             if (payload.location.country.code === 'IN') {
      //               if (
      //                 navigator.userAgent.match(
      //                   /(Mozilla\/5\.0 \(Linux; Android 11; moto g power \(2022\)\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0.0.0 Mobile Safari\/537\.36)|(Mozilla\/5\.0 \(Macintosh; Intel Mac OS X 10_15_7\) AppleWebKit\/537\.36 \(KHTML, like Gecko\) Chrome\/109\.0\.0\.0 Safari\/537\.36)|(Speed Insights)|(Chrome-Lighthouse)|(PSTS[\d\.]+)/
      //                 )
      //               ) {
      //               } else {
      //                 let pageUrls = 'https://www.behno.in' + window.location.pathname;
      //                 window.location.href = pageUrls;
      //               }
      //             }
      //           }
      //         });
      //     }
      //   });